var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"custom_logo",class:{ 'fade-in': _vm.visible },style:({ backgroundImage: _vm.src ? 'url(' + _vm.src + ')' : 'none' })})
}
var staticRenderFns = []

export { render, staticRenderFns }